<div class="td-wb-material-form-chips__container">
  <mat-chip-listbox #chipListbox
                    [attr.aria-label]="ariaLabel()"
                    [attr.aria-labelledby]="ariaLabelledBy()"
                    (change)="onListboxValueChange($event)"
                    [hideSingleSelectionIndicator]="hideSingleSelectionIndicator()"
                    [multiple]="multiple()"
                    [disabled]="disabled">
      @for (option of options(); track option) {
          <mat-chip-option [value]="option.value">
              <span [translate]="option.text"></span>
          </mat-chip-option>
      }
  </mat-chip-listbox>
</div>
